import AuthorizeService from '../services/authorize';
import { t } from '@/locales';

const AuthorizePlugin = {
	install(app, options = {}) {
		app.config.globalProperties.$can = (permission, arg = {}) => {
			return AuthorizeService.can(permission, arg);
		};

		app.config.globalProperties.$cannot = (permission, arg = {}) => {
			return AuthorizeService.cannot(permission, arg);
		};

		app.config.globalProperties.$canAll = (permission) => {
			return AuthorizeService.canAll(permission);
		};

		app.config.globalProperties.$canAny = (permissions) => {
			return AuthorizeService.canAny(permissions);
		};

		app.config.globalProperties.$cannotAll = (permissions) => {
			return AuthorizeService.cannotAll(permissions);
		};

		app.config.globalProperties.$cannotAny = (permissions) => {
			return AuthorizeService.cannotAny(permissions);
		};

		app.config.globalProperties.$getAllPermissions = () => {
			return AuthorizeService.getAllPermissions();
		};

		app.config.globalProperties.$unauthorizedMessage = (permission, arg = {}, fallback = '') => {
			return AuthorizeService.can(permission, arg) ? fallback : t('not-authorized', { permission });
		}

		app.config.globalProperties.$unauthorizedMessageAll = (permissions, fallback = '') => {
			const firstPermissionName = permissions[0][0];
			return AuthorizeService.canAll(permissions) ? fallback : t('not-authorized', { permission: firstPermissionName });
		}
	},
};

export default AuthorizePlugin; 